import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center px-4">
          <h1 className="mb-4 text-6xl font-heading font-bold text-foreground">
            404
          </h1>
          <p className="mb-6 text-xl text-muted-foreground">
            Oops! The page you're looking for doesn't exist.
          </p>
          <Link to="/">
            <Button className="font-semibold">
              <Home className="w-4 h-4 mr-2" />
              Return to Home
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
